(function($){
	"use strict";

	function openTab(tabSlug) {
		console.log(tabSlug);
		if (tabSlug == 'practice-quiz') {
			var $topProduct = $('#site-main > .container > .product'),
				$topProductTabs = $('#site-main > .container > .product > .woocommerce-tabs');
			$topProductTabs.find('> .woocommerce-Tabs-panel').hide();
			$topProductTabs.find('> [id*="'+tabSlug+'"]').show();
			console.log('p', $topProductTabs.find('> [id~="'+tabSlug+'"]'))
			$topProductTabs.find('> .tabs li').removeClass('active');
			$topProductTabs.find('> .tabs [id*="'+tabSlug+'"]').addClass('active');
		} else {
			var $topProduct = $('#site-main > .container > .product'),
				$topProductTabs = $('#site-main > .container > .product > .woocommerce-tabs');
			$topProductTabs.find('> .woocommerce-Tabs-panel').hide();
			$topProductTabs.find('> .woocommerce-Tabs-panel--' + tabSlug).show();
			$topProductTabs.find('> .tabs li').removeClass('active');
			$topProductTabs.find('> .tabs li#tab-title-' + tabSlug).addClass('active');
		}
	}

	jQuery(function($) {


		//$('.description_tab').click();

		$('#site-main > .container > .product > .woocommerce-tabs > ul > li > a').on('click', function() {
			//console.log('r');
			//$('.panel .description_tab a').click();
			setTimeout(function() {
				$('.woocommerce-tabs .woocommerce-tabs .woocommerce-Tabs-panel').hide();
				$('.woocommerce-tabs .woocommerce-tabs .woocommerce-Tabs-panel--description').show();
				$('.woocommerce-tabs .woocommerce-tabs .tabs li').removeClass('active');
				$('.woocommerce-tabs .woocommerce-tabs .tabs li.description_tab').addClass('active');
			},10);
		});

		$('body').on('added_to_cart', function(){

			console.log('product added');
		});

		$('button.product-column-teaser-read-more-btn').on('click', function(e) {

			$(this).parents('.product-row').find('.product-row-full-text').slideToggle();
			$(this).addClass('section-open');

		});

		$('[data-toggle="tooltip"]').tooltip();

		$('a[href="/our-courses"], a[href="/our-courses/"]').on('click', function(e) {
			e.preventDefault();
			$('.expanded-navigation').addClass('visible');
			setTimeout(function() {
				document.getElementById('all-courses-menu').scrollIntoView();
			},400);
		});
		$('.exam-btn').on('click', function(e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function(i) {
				if ($(this).attr('href').indexOf('#practice-quiz') == -1)
					$(this).attr('href', $(this).attr('href')+'#practice-quiz');
			});
			$('#all-courses .call-to-action').html('Select a trade to take a free test or call today for a free consultation @ <a href="tel:8666858564">1-866-685-8564</a>');

			$('.expanded-navigation').addClass('visible');
			setTimeout(function() {
				document.getElementById('all-courses-menu').scrollIntoView();
			},400);
		});
		$('.expand-courses-menu a').on('click', function(e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function(i) {
				$(this).attr('href', $(this).attr('href').replace('#practice-quiz',''));
			});
			$('#all-courses .call-to-action').html('Select a trade below or give us a call today for a free consultation @ <a href="tel:8666858564">1-866-685-8564</a>');
			$('.expanded-navigation').toggleClass('visible');
		});
		$('.expanded-navigation .close').on('click', function(e) {
			e.preventDefault();
			var $courseLinks = $('#all-courses-menu .course-link a');
			$courseLinks.each(function(i) {
				$(this).attr('href', $(this).attr('href').replace('#practice-quiz',''));
			});
			$('#all-courses .call-to-action').html('Select a trade below or give us a call today for a free consultation @ <a href="tel:8666858564">1-866-685-8564</a>');
			$('.expanded-navigation').removeClass('visible');
		});

		if (window.location.hash) {
			var hashValue = window.location.hash.split('#');
			if (hashValue.length > 1) hashValue = hashValue[1];

			openTab(hashValue);
		}

		$('#clear_shopping_cart').on('click', function(e) {
			$('input').val('');
			e.preventDefault();
		});
	});

})(jQuery);